import { lazy, Suspense } from 'react';
import { Navigate, type RouteObject } from 'react-router';
import { Guard } from '@/modules/shared/components/guard';

const AlunoHome = lazy(() => import('./pages/home'));

const QuizLayout = lazy(() => import('./pages/quiz/_layout'));
const ListaQuestoes = lazy(() => import('./pages/quiz/lista-questoes'));
const SelecionarOpcao = lazy(() => import('./pages/quiz/selecionar-opcao'));
const GerarQuiz = lazy(() => import('./pages/quiz/gerar-quiz'));

const AlunoGuard = ({ children, allowedRoles }: {
  children: React.ReactNode;
  allowedRoles: any[];
}) => (
  <Suspense fallback={<div className="min-h-screen" />}>
    <Guard allowedRoles={allowedRoles}>
      {children}
    </Guard>
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <AlunoGuard allowedRoles={['ALUNO', 'SUPER', 'ADM', 'PROFESSOR', 'RESPONSAVEL']}>
        <AlunoHome />
      </AlunoGuard>
    ),
    handle: { crumb: 'Home' }
  },
  {
    path: '/quiz',
    element: <Navigate replace to="/quiz/selecionar-opcao" />,
    handle: { crumb: null }
  },
  {
    path: '/quiz/responder/:quizId',
    element: <Navigate replace to="/quiz/lista-questoes" />,
    handle: { crumb: 'Responder Quiz' }
  },
  {
    path: '/quiz/responder/:quizId/resultado',
    element: <Navigate replace to="/quiz/historico-professor" />,
    handle: { crumb: 'Resultado Quiz' }
  },
  {
    path: '/quiz',
    element: (
      <AlunoGuard allowedRoles={['ALUNO', 'SUPER', 'ADM', 'PROFESSOR']}>
        <QuizLayout />
      </AlunoGuard>
    ),
    handle: { crumb: 'Quiz' },
    children: [
      {
        index: true,
        element: <SelecionarOpcao />,
        handle: { crumb: 'Selecionar Opção' }
      },
      {
        path: 'selecionar-opcao',
        element: <SelecionarOpcao />,
        handle: { crumb: 'Selecionar Opção' }
      },
      {
        path: 'lista-questoes',
        element: <ListaQuestoes />,
        handle: { crumb: 'Questões' }
      },
      {
        path: 'gerar-quiz',
        element: <GerarQuiz />,
        handle: { crumb: 'Gerar Quiz' }
      }
    ]
  }
];

export default routes;
